const ROUTES = {};

ROUTES.ROOT = '/';

// Pages

ROUTES.PAGE_403 = '/403/*';
ROUTES.PAGE_404 = '/404/*';

ROUTES.MANAGE = '/manage';
ROUTES.MANAGE_USER = '/manage/user/:id';

ROUTES.IDENTITY_PROFILE = '/profile';
ROUTES.ADMIN = '/admin';
ROUTES.ADMIN_INVITES = '/admin/invites/:status?';
ROUTES.ADMIN_FEEDBACK = '/admin/feedback';

ROUTES.UI_KIT = '/ui-kit';

ROUTES.BILLING = '/billing/:tab?';
ROUTES.BILLING_INVOICE = '/billing/invoice/:number';

// Pages: App

ROUTES.APP = '/app/:appId';
ROUTES.APP_ANY = '/app/:appId?/*';
ROUTES.APP_OLD_ANY = '/application/:appId?/*';

ROUTES.APP_SETTINGS = `${ ROUTES.APP }/settings`;

ROUTES.CAMPAIGNS = `${ ROUTES.APP }/campaigns`;
ROUTES.CAMPAIGNS_CREATE = `${ ROUTES.APP }/campaigns/create`;
ROUTES.CAMPAIGNS_DRAFTS = `${ ROUTES.APP }/campaigns/drafts`;
ROUTES.CAMPAIGN = `${ ROUTES.APP }/campaigns/:id/:tab?`;

ROUTES.AUDIENCES = `${ ROUTES.APP }/audiences`;
ROUTES.AUDIENCE_VIEW = `${ ROUTES.APP }/audiences/:audId/:tab?`;

ROUTES.CREATIVES = `${ ROUTES.APP }/creatives/:tab?`;

ROUTES.CONVERSIONS = `${ ROUTES.APP }/conversions`;
ROUTES.CONVERSION = `${ ROUTES.APP }/conversions/:id/:tab?`;
ROUTES.CONVERSION_SEGMENT = `${ ROUTES.APP }/conversions/segment/:id/:tab?`;

ROUTES.ADS_ACCOUNTS = `${ ROUTES.APP }/adsAccounts`;
ROUTES.ADS_ACCOUNTS_EDIT = `${ ROUTES.APP }/adsAccounts/:accId`;

ROUTES.DATA_SOURCES = `${ ROUTES.APP }/dataSources`;
ROUTES.DATA_SOURCE_EDIT = `${ ROUTES.APP }/dataSources/:dsId`;

ROUTES.INSIGHTS = `${ ROUTES.APP }/insights/:tab?`;

ROUTES.PREDICTIONS = `${ ROUTES.APP }/predictions`;
ROUTES.PREDICTION = `${ ROUTES.APP }/predictions/:convId`;


// Pages: Advertiser
ROUTES.ADVER = {};
ROUTES.ADVER.LIST = '/advertisers';
ROUTES.ADVER.ROOT = '/adver/:adverId';
ROUTES.ADVER.ANY = '/adver/:adverId?/*';

ROUTES.ADVER.APPS = '/adver/:adverId/apps';
ROUTES.ADVER.APP_SETTINGS = '/adver/:adverId/apps/:appId/settings';
ROUTES.ADVER.CAMPAIGNS = '/adver/:adverId/campaigns';
ROUTES.ADVER.CAMPAIGNS_CREATE = '/adver/:adverId/campaigns/create';
ROUTES.ADVER.CAMPAIGNS_DRAFTS = '/adver/:adverId/campaigns/drafts';
ROUTES.ADVER.CAMPAIGN = '/adver/:adverId/campaigns/:id/:tab?';

ROUTES.ADVER.AUDIENCES = '/adver/:adverId/audiences';
ROUTES.ADVER.AUDIENCE_VIEW = '/adver/:adverId/audiences/:audId/:tab?';

ROUTES.ADVER.CREATIVES = '/adver/:adverId/creatives/:tab?';

ROUTES.ADVER.DATA_SOURCES = '/adver/:adverId/dataSources';
ROUTES.ADVER.DATA_SOURCE_EDIT = '/adver/:adverId/dataSources/:dsId';

ROUTES.ADVER.ADS_ACCOUNTS = '/adver/:adverId/adsAccounts';
ROUTES.ADVER.ADS_ACCOUNTS_CREATE = '/adver/:adverId/adsAccounts/create';
ROUTES.ADVER.ADS_ACCOUNTS_EDIT = '/adver/:adverId/adsAccounts/:accId';

// Redirects
ROUTES.CHANGE_PSWD = '/restore/:token';
ROUTES.ACTIVATE = '/activation/:token';
ROUTES.ACTIVATE_INVITED = '/signup/manager/:token';

// Google Auth returns user to this page
// Can only be changed together with the option at Google panel
ROUTES.GOOGLE_OAUTH_CALLBACK = '/google/callback';


// API
ROUTES.API = {};
ROUTES.API.ROOT = '/api';

ROUTES.API.ACC_USERS = '/users/:id';
ROUTES.API.ACC_USER_RESET_PSWD = '/users/:id/resetPassword';
ROUTES.API.ACC_INVITES = '/invites';

ROUTES.API.IDENTITY_AUTH = '/auth/authenticate'; // POST Credentials => Me
ROUTES.API.IDENTITY_INFO = '/auth/me'; // GET => Me
ROUTES.API.IDENTITY_INVITE_ME = '/invite'; // POST
ROUTES.API.IDENTITY_REQUEST_CHANGE_PSWD = '/auth/sendForgotLink'; // ;x
ROUTES.API.IDENTITY_CHANGE_PSWD = '/auth/reset'; // POST {token, pass}
ROUTES.API.IDENTITY_ACTIVATE = '/auth/getByActivationString'; // ;x
ROUTES.API.IDENTITY_ACTIVATE_INVITED = '/auth/activate';
ROUTES.API.IDENTITY_LOGOUT = '/auth/logout'; // POST

ROUTES.API.FILES = '/file/:id/:fileName';
ROUTES.API.FILES_INFO = '/file/:id/info';

ROUTES.API.FEEDBACK = '/feedback/:id';
ROUTES.API.FEEDBACK_ARCHIVE = '/feedback/:id/archive';

ROUTES.API.APPS = '/apps/:id';
ROUTES.API.APPS_PREVIEW = '/apps/preview';
ROUTES.API.APP_PREVIEW_PNG = '/apps/:id/preview.png';
ROUTES.API.APP_SOURCES = '/apps/:id/sources';
ROUTES.API.APP_DEPS = '/apps/:id/deps';

ROUTES.API.ADVERTISERS = '/advertisers/:id';
ROUTES.API.ADVER_PREVIEW_PNG = '/advertisers/:id/preview.png';

ROUTES.API.HISTORY = '/history/:entity/:id';

ROUTES.API.GOOGLE_OAUTH = '/goauth2';
ROUTES.API.GOOGLE_REDIRECT = '/goauth2/:type/redirectUrl';
ROUTES.API.GOOGLE_CALLBACK = '/goauth2/callback';
ROUTES.API.GOOGLE_CHILD_ACCS = '/goauth2/listAccounts';
ROUTES.API.GOOGLE_CREATE_ACC = '/goauth2/createAccount';

//// App Context
ROUTES.API.APP = {};

ROUTES.API.APP.CAMPAIGNS = '/app/:appId/campaigns/:id';
ROUTES.API.APP.CAMPAIGNS_PRESETS = '/app/:appId/campaigns/presets';

ROUTES.API.APP.AUDITORIES = '/app/:appId/audiences/:id';
ROUTES.API.APP.AUDITORY_STATS = '/app/:appId/audiences/:id/stats';
ROUTES.API.APP.AUDITORY_DEPS = '/app/:appId/audiences/:id/deps';
ROUTES.API.APP.AUDITORY_DOWNLOAD = '/app/:appId/audiences/:id/download/:downloadId/:fileName';
ROUTES.API.APP.AUDITORY_ADS_ACCOUNTS = '/app/:appId/audiences/:audId/adsAccounts/:id';

ROUTES.API.APP.CREATIVES = '/app/:appId/creatives/:id';
ROUTES.API.APP.CREATIVE_SET_STATUS = '/app/:appId/creatives/:id/setStatus';
ROUTES.API.APP.CREATIVE_DEPS = '/app/:appId/creatives/:id/deps';

ROUTES.API.APP.CONVERSIONS = '/app/:appId/conversions/:id';
ROUTES.API.APP.CONVERSIONS_ADS_ACCOUNTS = '/app/:appId/conversions/:convId/adsAccounts/:id';
// ROUTES.API.APP.CONVERSIONS_LITE = '/app/:appId/conversions/lite';
ROUTES.API.APP.CONVERSIONS_LITE = '/app/:appId/conversions/v2/lite';
ROUTES.API.APP.SEGMENTS = '/app/:appId/conversionSegments/:id';


ROUTES.API.APP.DATA_SOURCES = '/app/:appId/dataSources/:id';

ROUTES.API.APP_LINKS = '/app/:appId/applinks/:id';

ROUTES.API.APP.ADS_ACCOUNTS = '/app/:appId/adsAccounts/:id';

ROUTES.API.APP.PREDICTIONS = '/app/:appId/predictions/:convId';
ROUTES.API.APP.PREDICTION_RESULTS = '/app/:appId/predictions/:convId/results';
ROUTES.API.APP.INSIGHTS_EVENT_ACHIEVEMENT = '/app/:appId/insights/event-achievement';
ROUTES.API.APP.INSIGHTS_CONVERSION_RATE = '/app/:appId/insights/conversion-rate';
ROUTES.API.APP.INSIGHTS_FUNNELS = '/app/:appId/insights/funnel';
ROUTES.API.APP.GEO_REPORT = '/app/:appId/insights/geo-report';

//// Advertiser Context

ROUTES.API.CAMPAIGNS = '/campaigns/:id';
ROUTES.API.CAMPAIGNS_PRESETS = '/campaigns/presets';
ROUTES.API.CRTV_GROUPS = '/creativeGroups/:id';

ROUTES.API.AUDITORIES = '/audiences/:id';
ROUTES.API.AUDITORY_STATS = '/audiences/:id/stats';
ROUTES.API.AUDITORY_DEPS = '/audiences/:id/deps';
ROUTES.API.AUDITORY_DOWNLOAD = '/audiences/:id/download/:downloadId/:fileName';
ROUTES.API.AUDITORY_ADS_ACCOUNTS = '/audiences/:audId/adsAccounts/:id';

ROUTES.API.CREATIVES = '/creatives/:id';
ROUTES.API.CREATIVE_SET_STATUS = '/creatives/:id/setStatus';
ROUTES.API.CREATIVE_DEPS = '/creatives/:id/deps';

ROUTES.API.CONVERSIONS = '/conversions/:id';
ROUTES.API.CONVERSIONS_ADS_ACCOUNTS = '/conversions/:convId/adsAccounts/:id';
// ROUTES.API.CONVERSIONS_LITE = '/conversions/lite';
ROUTES.API.CONVERSIONS_LITE = '/conversions/v2/lite';
ROUTES.API.EVENT_TYPES_LITE = '/eventTypes/lite';
ROUTES.API.SEGMENTS = '/conversionSegments/:id';

ROUTES.API.DATA_SOURCES = '/dataSources/:id';

ROUTES.API_LINKS = '/applinks/:id';

ROUTES.API.ADS_ACCOUNTS = '/adsAccounts/:id';

// ROUTES.API.PREDICTIONS = '/predictions/:convId';
// ROUTES.API.PREDICTION_RESULTS = '/predictions/:convId/results';
// ROUTES.API.INSIGHTS_EVENT_ACHIEVEMENT = '/insights/event-achievement';
// ROUTES.API.INSIGHTS_CONVERSION_RATE = '/insights/conversion-rate';
// ROUTES.API.INSIGHTS_FUNNELS = '/insights/funnel';
// ROUTES.API.GEO_REPORT = '/insights/geo-report';

// --
// function prefixes (obj, prefix) {
//   Object.keys(obj).forEach(key => { obj[key] = `${ prefix }${ obj[key] }` })
// }


Object.freeze(ROUTES.API);
Object.freeze(ROUTES.API.APP);

ROUTES.ctxify = function (name) {
  const { appId, adverId } = window.$App;
  if (appId)
    return ROUTES[name];
  if (adverId)
    return ROUTES.ADVER[name];
  throw new Error('getContextRoute(): context route was request without adverId or appId');
};


Object.freeze(ROUTES);

export default ROUTES;

